// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"4561b77a","374":"5574dc22","738":"3c9654d1","777":"ffbcf090","787":"53bee53e","903":"b2c538b4"}[chunkId] + ".chunk.js";
};